import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import SelectSearchable from "components/Select";
import { Row, Col } from "react-flexbox-grid/lib/index";

const TimeZoneLine = props => {
  const options = moment.tz.names();

  // handler to deal with null values when clearing timezone value
  const handleTimeZoneChange = e => {
    if (e === null) {
      props.onTimeZoneChange("");
    } else {
      props.onTimeZoneChange(e.value);
    }
  };

  return (
    <Row style={{ marginLeft: 4, marginTop: 8 }}>
      <Col xs={4}>
        <SelectSearchable
          value={props.timeZone}
          isClearable
          options={options}
          label="Time zone"
          onChange={handleTimeZoneChange}
        />
      </Col>
    </Row>
  );
};
TimeZoneLine.propTypes = {
  onTimeZoneChange: PropTypes.func.isRequired,
  actions: PropTypes.shape({ advAdd: PropTypes.func.isRequired }).isRequired,
  timeZone: PropTypes.string
};
TimeZoneLine.defaultProps = {
  timeZone: ""
};

export default TimeZoneLine;
